import {authMiddleware} from "./loginAction";
import cfg, {handleResponse} from "../constants";

/**
 * Болталки канала DiChat — групповые комнаты на несколько клиенток.
 *
 * Куратора и поддержки в них нет по замыслу: болталка для разговора участниц
 * между собой. Состав хранится в CRM, а Matrix — исполнитель: сервер приглашает
 * и выводит, панель только говорит, кого и куда.
 */

// dichatGroupsAction - список болталок
export const dichatGroupsAction = (withDeleted = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/dichat-groups' + (withDeleted ? '?with_deleted=1' : ''), {
    headers
  }).then(handleResponse);
};

// dichatGroupsForClientAction - болталки для выбора у клиентки.
//
// Порядок задаёт сервер: болталка, из которой её выводили последней, идёт первой
// и помечена previous — вернуть чаще всего надо именно туда. Решение при этом за
// человеком: молча увести клиентку не в ту комнату, которую выбрал куратор,
// значит потом объяснять это поддержке.
export const dichatGroupsForClientAction = (client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/dichat-groups/client/' + client_id, {
    headers
  }).then(handleResponse);
};

// dichatGroupCreateAction - завести болталку
export const dichatGroupCreateAction = (title) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/dichat-groups', {
    method: "POST",
    body: JSON.stringify({title}),
    headers
  }).then(handleResponse);
};

// dichatGroupUpdateAction - переименовать, удалить или вернуть.
//
// Одной ручкой: в панели это одна форма правки, и разносить её на две незачем.
// Удаление — пометка, а не исчезновение: комнату в Matrix по-настоящему не
// удалить, её можно только опустошить.
export const dichatGroupUpdateAction = (id, body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/dichat-groups/' + id, {
    method: "PUT",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse);
};

// dichatGroupAddClientAction - добавить клиентку в болталку
export const dichatGroupAddClientAction = (id, client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/dichat-groups/' + id + '/client/' + client_id, {
    method: "POST",
    headers
  }).then(handleResponse);
};

// dichatGroupRemoveClientAction - убрать клиентку из болталки.
//
// Сервер запоминает, откуда её вывели: в следующем списке эта болталка окажется
// первой и подсвеченной.
export const dichatGroupRemoveClientAction = (id, client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/dichat-groups/' + id + '/client/' + client_id, {
    method: "DELETE",
    headers
  }).then(handleResponse);
};
